(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["moru-cart-discount-summary"] && !Shopify.designMode) return;
  try {
    
  class MoruCartDiscountSummary extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.currency = 'JPY';
      this.onUpdated = () => this.refresh();
      this.onClick = (event) => {
        const button = event.target.closest('[data-moru-member-coupon-copy]');
        if (!button) return;
        this.copyMemberCoupon(button);
      };
      document.addEventListener('moru:cart:updated', this.onUpdated);
      document.addEventListener('click', this.onClick);
      this.renderMemberCoupon();
      this.refresh();
    }

    disconnectedCallback() {
      document.removeEventListener('moru:cart:updated', this.onUpdated);
      document.removeEventListener('click', this.onClick);
    }

    get rootUrl() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

    formatMoney(cents) {
      try { return new Intl.NumberFormat('ja-JP', { style:'currency', currency:this.currency, maximumFractionDigits:0 }).format(cents / 100); }
      catch (error) { return '¥' + Math.round(cents / 100).toLocaleString('ja-JP'); }
    }

    renderMemberCoupon() {
      const summary = document.querySelector('.moru-cart__summary');
      if (!summary) return;
      summary.querySelector('[data-moru-member-coupon]')?.remove();
      const template = this.querySelector('[data-moru-member-coupon-template]');
      if (!template) return;
      const couponBlock = summary.querySelector('[data-coupon-block]');
      const card = template.content.firstElementChild.cloneNode(true);
      if (couponBlock) summary.insertBefore(card, couponBlock);
      else summary.prepend(card);
    }

    async copyMemberCoupon(button) {
      const code = button.dataset.code || '';
      if (!code) return;
      let copied = false;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
          copied = true;
        }
      } catch (error) {}
      if (!copied) {
        const input = document.createElement('textarea');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        try { copied = document.execCommand('copy'); } catch (error) {}
        input.remove();
      }
      if (!copied) return;
      const card = button.closest('[data-moru-member-coupon]');
      const status = card && card.querySelector('[data-moru-member-coupon-status]');
      if (status) {
        status.hidden = false;
        window.clearTimeout(this.copyStatusTimer);
        this.copyStatusTimer = window.setTimeout(() => { status.hidden = true; }, 2400);
      }
    }

    async refresh() {
      this.renderMemberCoupon();
      try {
        const response = await fetch(this.rootUrl + 'cart.js', { headers:{ Accept:'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        this.currency = cart.currency || this.currency;
        this.updateLines(cart);
        this.updateSummary(cart);
      } catch (error) {}
    }

    updateLines(cart) {
      const rows = Array.from(document.querySelectorAll('.moru-cart__item'));
      rows.forEach((row, index) => {
        const price = row.querySelector('.moru-cart__item-price');
        if (!price) return;
        price.querySelector('.moru-cart__item-saving')?.remove();
        price.classList.remove('has-moru-discount');
        const item = cart.items && cart.items[index];
        if (!item) return;
        const saving = Math.max(0, Number(item.original_line_price || 0) - Number(item.final_line_price || 0));
        if (saving <= 0) return;
        price.classList.add('has-moru-discount');
        const badge = document.createElement('small');
        badge.className = 'moru-cart__item-saving';
        badge.textContent = this.formatMoney(saving) + ' お得';
        price.appendChild(badge);
      });
    }

    updateSummary(cart) {
      const summary = document.querySelector('.moru-cart__summary');
      const total = summary && summary.querySelector('.moru-cart__total');
      if (!summary || !total) return;
      summary.querySelector('[data-moru-cart-discount-summary]')?.remove();
      const totalLabel = total.querySelector('.moru-cart__total-label');
      const discount = Number(cart.total_discount || 0);
      // 送料割引: 割引前小計がしきい値以上なら送料ぶんもお得として合算する(D-127 と同じ基準)
      const shippingFee = (parseInt(this.dataset.shippingFee, 10) || 870) * 100;
      const freeThreshold = (parseInt(this.dataset.freeThreshold, 10) || 7700) * 100;
      const originalTotal = Number(cart.original_total_price || 0) || (Number(cart.total_price || 0) + discount);
      const shippingSaving = originalTotal >= freeThreshold ? shippingFee : 0;
      const totalSaving = discount + shippingSaving;
      if (totalSaving <= 0) {
        if (totalLabel && totalLabel.dataset.moruOriginalLabel) totalLabel.textContent = totalLabel.dataset.moruOriginalLabel;
        return;
      }

      if (totalLabel) {
        if (!totalLabel.dataset.moruOriginalLabel) totalLabel.dataset.moruOriginalLabel = totalLabel.textContent.trim();
        totalLabel.textContent = '割引後合計';
      }

      const box = document.createElement('div');
      box.className = 'moru-cart__discount-summary';
      box.dataset.moruCartDiscountSummary = 'true';
      box.innerHTML = `
        <div class="moru-cart__discount-summary-row"><span>通常合計</span><s>${this.formatMoney(originalTotal)}</s></div>
        <div class="moru-cart__discount-summary-row moru-cart__discount-summary-row--saving"><span>割引合計</span><strong>−${this.formatMoney(totalSaving)}</strong></div>
        <p class="moru-cart__discount-summary-total">合計 ${this.formatMoney(totalSaving)} お得</p>
      `;
      total.parentNode.insertBefore(box, total);
    }
  }

  if (!customElements.get('moru-cart-discount-summary')) customElements.define('moru-cart-discount-summary', MoruCartDiscountSummary);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moru-cart-drawer-v2"] && !Shopify.designMode) return;
  try {
    
  class MoruCartDrawerV2 extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId; this.opener = null;
      this.addEventListener('click', (event) => { if (event.target.closest('[data-drawer-close]') || event.target.closest('[data-drawer-backdrop]')) { this.close(); return; } const minus=event.target.closest('[data-drawer-minus]'); const plus=event.target.closest('[data-drawer-plus]'); const remove=event.target.closest('[data-drawer-remove]'); if(!minus&&!plus&&!remove)return; const item=(minus||plus||remove).closest('[data-line]'); if(!item)return; if(remove){this.change(item.dataset.line,0);return;} const current=parseInt(item.querySelector('[data-drawer-qty]').textContent,10)||0; this.change(item.dataset.line,Math.max(0,current+(plus?1:-1))); });
      document.addEventListener('click',(event)=>{const toggle=event.target.closest('[data-cart-drawer-toggle]');if(!toggle||this.dataset.pageType==='cart')return;event.preventDefault();this.open(toggle);});
      document.addEventListener('keydown',(event)=>{if(event.key==='Escape'&&this.classList.contains('is-open'))this.close();});
      if(this.dataset.interceptAdd==='true'&&this.dataset.pageType!=='cart')document.addEventListener('submit',(event)=>this.onProductSubmit(event));
    }
    get rootUrl(){return(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';}
    open(opener){if(opener)this.opener=opener;this.classList.add('is-open');this.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';window.setTimeout(()=>this.querySelector('[data-drawer-close]')?.focus(),100);}
    close(){this.classList.remove('is-open');this.setAttribute('aria-hidden','true');document.body.style.overflow='';this.opener?.focus?.();}
    async onProductSubmit(event){if(event.defaultPrevented)return;const form=event.target.closest('form');if(!form||!(form.getAttribute('action')||'').includes('/cart/add'))return;event.preventDefault();const button=form.querySelector('[type="submit"]');if(button)button.disabled=true;try{const response=await fetch(this.rootUrl+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});if(!response.ok)throw new Error('add failed');await this.refresh();this.open();}catch(error){form.submit();}finally{if(button)button.disabled=false;}}
    async change(line,quantity){this.classList.add('is-busy');try{const response=await fetch(this.rootUrl+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:Number(line),quantity})});if(!response.ok)throw new Error('change failed');await this.refresh();}catch(error){window.location.reload();}finally{this.classList.remove('is-busy');}}
    async refresh(){const response=await fetch(window.location.pathname+'?section_id='+this.sectionId);const parsed=new DOMParser().parseFromString(await response.text(),'text/html');const next=parsed.querySelector('[data-cart-drawer]');if(!next){window.location.reload();return;}const wasOpen=this.classList.contains('is-open');this.innerHTML=next.innerHTML;if(wasOpen)this.classList.add('is-open');await this.syncBadge();document.dispatchEvent(new CustomEvent('moru:cart:updated'));}
    async syncBadge(){try{const response=await fetch(this.rootUrl+'cart.js',{headers:{Accept:'application/json'}});const cart=await response.json();document.querySelectorAll('[data-cart-count]').forEach((badge)=>{badge.textContent=cart.item_count;});}catch(error){}}
  }
  if(!customElements.get('moru-cart-drawer-v2'))customElements.define('moru-cart-drawer-v2',MoruCartDrawerV2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moru-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  class MoruCartDrawer extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.opener = null;

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-drawer-close]') || event.target.closest('[data-drawer-backdrop]')) {
          this.close();
          return;
        }

        const minus = event.target.closest('[data-drawer-minus]');
        const plus = event.target.closest('[data-drawer-plus]');
        const remove = event.target.closest('[data-drawer-remove]');
        if (!minus && !plus && !remove) return;

        const item = (minus || plus || remove).closest('[data-line]');
        if (!item) return;

        if (remove) {
          this.change(item.dataset.line, 0);
          return;
        }

        const current = parseInt(item.querySelector('[data-drawer-qty]').textContent, 10) || 0;
        this.change(item.dataset.line, Math.max(0, current + (plus ? 1 : -1)));
      });

      document.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-cart-drawer-toggle]');
        if (!toggle) return;
        // On the cart page itself the drawer would duplicate the page it sits on,
        // so the icon keeps its plain link behaviour there.
        if (this.dataset.pageType === 'cart') return;
        event.preventDefault();
        this.open(toggle);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
      });

      if (this.dataset.interceptAdd === 'true' && this.dataset.pageType !== 'cart') {
        document.addEventListener('submit', (event) => this.onProductSubmit(event));
      }
    }

    get rootUrl() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    open(opener) {
      if (opener) this.opener = opener;
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      window.setTimeout(() => this.querySelector('[data-drawer-close]')?.focus(), 120);
    }

    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (this.opener && typeof this.opener.focus === 'function') this.opener.focus();
    }

    async onProductSubmit(event) {
      const form = event.target.closest('form');
      if (!form) return;

      const action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      event.preventDefault();
      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton) submitButton.disabled = true;

      try {
        const data = new FormData(form);
        const variantId = Number(data.get('id'));
        const wanted = Number(data.get('quantity') || 1);
        const existing = await this.findLine(variantId);

        if (existing) {
          // Already held: raise the quantity on that line so its _added_at —
          // and therefore its countdown — carries on from the first add.
          await this.postJson('cart/change.js', {
            line: existing.line,
            quantity: existing.quantity + wanted,
          });
        } else {
          if (this.holdEnabled) data.append('properties[_added_at]', String(Date.now()));
          const response = await fetch(this.rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: data,
          });
          if (!response.ok) throw new Error('add failed');
        }

        await this.refresh();
        this.open();
      } catch (error) {
        form.submit();
      } finally {
        if (submitButton) submitButton.disabled = false;
      }
    }

    get holdEnabled() {
      return this.dataset.holdEnabled === 'true';
    }

    async postJson(path, body) {
      const response = await fetch(this.rootUrl + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      if (!response.ok) throw new Error(path + ' failed');
      return response.json();
    }

    async findLine(variantId) {
      const response = await fetch(this.rootUrl + 'cart.js', { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      const index = (cart.items || []).findIndex((item) => item.variant_id === variantId);
      if (index === -1) return null;
      return { line: index + 1, quantity: cart.items[index].quantity };
    }

    async change(line, quantity) {
      this.classList.add('is-busy');
      try {
        const response = await fetch(this.rootUrl + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: quantity }),
        });
        if (!response.ok) throw new Error('change failed');
        await this.refresh();
      } catch (error) {
        window.location.reload();
      } finally {
        this.classList.remove('is-busy');
      }
    }

    async refresh() {
      const response = await fetch(window.location.pathname + '?section_id=' + this.sectionId);
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = parsed.querySelector('[data-cart-drawer]');
      if (!next) {
        window.location.reload();
        return;
      }

      const wasOpen = this.classList.contains('is-open');
      this.innerHTML = next.innerHTML;
      if (wasOpen) this.classList.add('is-open');

      await this.syncBadge();
      document.dispatchEvent(new CustomEvent('moru:cart:updated'));
    }

    async syncBadge() {
      const badges = document.querySelectorAll('[data-cart-count]');
      if (badges.length === 0) return;
      try {
        const response = await fetch(this.rootUrl + 'cart.js', { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        badges.forEach((badge) => {
          badge.textContent = cart.item_count;
        });
      } catch (error) {
        /* the badge keeps its previous value until the next page load */
      }
    }
  }

  if (!customElements.get('moru-cart-drawer')) {
    customElements.define('moru-cart-drawer', MoruCartDrawer);
  }

  /**
   * Cart hold.
   *
   * Every line stamped with a private _added_at property carries a deadline.
   * Until it passes, each [data-hold-until] element counts down; once it does,
   * the line is really removed with cart/change.js — the countdown is not
   * decoration over a cart that quietly stays put.
   *
   * Shopify does not reserve inventory for carts, so this frees nothing for
   * anyone else. What it does is empty this shopper's own cart, which is also
   * what the per-viewer stock number on the product page is counting.
   */
  function moruFormatHold(ms) {
    const total = Math.max(0, Math.floor(ms / 1000));
    const pad = (n) => String(n).padStart(2, '0');
    return pad(Math.floor(total / 3600)) + ':' + pad(Math.floor((total % 3600) / 60)) + ':' + pad(total % 60);
  }

  let moruHoldClearing = false;

  async function moruClearExpired(lines) {
    if (moruHoldClearing || lines.length === 0) return;
    moruHoldClearing = true;
    const drawer = document.querySelector('[data-cart-drawer]');
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    try {
      // Highest line first: removing a line renumbers the ones after it.
      for (const line of lines.sort((a, b) => b - a)) {
        await fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 }),
        });
      }
      if (drawer && typeof drawer.refresh === 'function') {
        await drawer.refresh();
      } else {
        window.location.reload();
      }
    } catch (error) {
      /* leave the cart alone; the next tick tries again */
    } finally {
      moruHoldClearing = false;
    }
  }

  function moruTickHolds() {
    const nodes = document.querySelectorAll('[data-hold-until]');
    if (nodes.length === 0) return;

    const now = Date.now();
    const expiredLines = [];

    nodes.forEach((node) => {
      const until = Number(node.dataset.holdUntil);
      if (!until) return;
      const left = until - now;

      if (left <= 0) {
        node.textContent = node.dataset.holdExpired || '';
        const line = Number(node.dataset.holdLine);
        // Submit each expired line once. Without this a failed removal — or a
        // refresh that returns the line again — would POST every second.
        if (line && node.dataset.holdCleared !== 'true') {
          node.dataset.holdCleared = 'true';
          expiredLines.push(line);
        }
        return;
      }

      const template = node.dataset.holdTemplate || '__TIME__';
      node.textContent = template.replace('__TIME__', moruFormatHold(left));
    });

    // The cart page and the drawer render the same cart, so one line can be
    // reported twice in a tick.
    if (expiredLines.length > 0) moruClearExpired(Array.from(new Set(expiredLines)));
  }

  moruTickHolds();
  window.setInterval(moruTickHolds, 1000);
  document.addEventListener('moru:cart:updated', moruTickHolds);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moru-category-browser"] && !Shopify.designMode) return;
  try {
    
  class MoruCategoryTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-moru-category-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-moru-category-panel]'));

      this.onClick = this.onClick || this.handleClick.bind(this);
      this.onKeydown = this.onKeydown || this.handleKeydown.bind(this);

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      if (this.onClick) this.removeEventListener('click', this.onClick);
      if (this.onKeydown) this.removeEventListener('keydown', this.onKeydown);
    }

    handleClick(event) {
      const tab = event.target.closest('[data-moru-category-tab]');
      if (!tab || !this.contains(tab)) return;
      this.activate(tab, false);
    }

    handleKeydown(event) {
      const tab = event.target.closest('[data-moru-category-tab]');
      if (!tab || !this.contains(tab)) return;

      const index = this.tabs.indexOf(tab);
      if (index < 0) return;

      let nextIndex = null;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === null) return;

      event.preventDefault();
      this.activate(this.tabs[nextIndex], true);
    }

    activate(activeTab, shouldFocus) {
      const targetId = activeTab.dataset.target;

      this.tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== targetId;
      });

      if (shouldFocus) activeTab.focus();
    }
  }

  if (!customElements.get('moru-category-tabs')) {
    customElements.define('moru-category-tabs', MoruCategoryTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moru-collection-grid"] && !Shopify.designMode) return;
  try {
    
  class MoruCollectionGrid {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.items = root.querySelector('[data-grid-items]');
      this.button = root.querySelector('[data-load-more]');
      this.shownText = root.querySelector('[data-shown-text]');

      const sortSelect = root.querySelector('[data-sort-select]');
      if (sortSelect) {
        sortSelect.addEventListener('change', () => {
          const form = sortSelect.closest('form');
          if (form) form.submit();
        });
      }

      if (this.button) {
        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          this.loadMore();
        });
      }
    }

    async loadMore() {
      const url = this.button.getAttribute('href');
      if (!url || !this.items) return;

      const original = this.button.textContent;
      this.button.setAttribute('aria-disabled', 'true');
      this.button.textContent = this.button.dataset.loadingLabel || original;

      try {
        const separator = url.indexOf('?') > -1 ? '&' : '?';
        const response = await fetch(url + separator + 'sections=' + this.sectionId);
        const data = await response.json();
        const html = data[this.sectionId];
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        const newItems = parsed.querySelector('[data-grid-items]');
        if (newItems) {
          Array.from(newItems.children).forEach((child) => this.items.appendChild(child));
        }

        const newShown = parsed.querySelector('[data-shown-text]');
        if (newShown && this.shownText) this.shownText.textContent = newShown.textContent;

        const newButton = parsed.querySelector('[data-load-more]');
        if (newButton) {
          this.button.setAttribute('href', newButton.getAttribute('href'));
          this.button.textContent = original;
          this.button.removeAttribute('aria-disabled');
        } else {
          this.button.remove();
        }
      } catch (error) {
        this.button.textContent = original;
        this.button.removeAttribute('aria-disabled');
      }
    }
  }

  document.querySelectorAll('[data-collection-grid]').forEach((root) => {
    if (root.dataset.moruInit === 'true') return;
    root.dataset.moruInit = 'true';
    new MoruCollectionGrid(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moru-coupon-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var popup = document.querySelector('[data-coupon-popup]');
    if (!popup) return;

    var STORAGE_KEY = 'moru-coupon-popup:dismissed-at';
    var suppressDays = parseInt(popup.dataset.suppressDays, 10) || 7;
    var threshold = parseInt(popup.dataset.scrollThreshold, 10) || 300;

    function storageGet() {
      try { return window.localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
    }
    function storageSet(value) {
      try { window.localStorage.setItem(STORAGE_KEY, value); } catch (e) { /* private mode */ }
    }

    var dismissedAt = parseInt(storageGet(), 10);
    if (dismissedAt && Date.now() - dismissedAt < suppressDays * 86400000) return;

    var shown = false;
    function show() {
      if (shown) return;
      shown = true;
      popup.hidden = false;
      window.requestAnimationFrame(function () { popup.classList.add('is-visible'); });
      window.removeEventListener('scroll', onScroll);
    }
    function dismiss() {
      storageSet(String(Date.now()));
      popup.classList.remove('is-visible');
      window.setTimeout(function () { popup.hidden = true; }, 320);
    }

    function onScroll() {
      if (window.scrollY > threshold) show();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    popup.querySelector('[data-coupon-popup-close]').addEventListener('click', dismiss);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && shown && !popup.hidden) dismiss();
    });

    var cta = popup.querySelector('[data-coupon-popup-cta]');
    if (cta) cta.addEventListener('click', function () { storageSet(String(Date.now())); });

    var copyButton = popup.querySelector('[data-coupon-popup-copy]');
    if (copyButton) {
      copyButton.addEventListener('click', function () {
        var code = popup.querySelector('[data-coupon-popup-code]').textContent.trim();
        var markCopied = function () {
          copyButton.textContent = copyButton.dataset.copiedLabel;
          window.setTimeout(function () { copyButton.textContent = copyButton.dataset.copyLabel; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(markCopied);
        } else {
          var textarea = document.createElement('textarea');
          textarea.value = code;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
          markCopied();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moru-header-v2"] && !Shopify.designMode) return;
  try {
    
  class MoruHeaderV2 extends HTMLElement { connectedCallback(){this.drawer=this.querySelector('[data-nav-drawer]');this.backdrop=this.querySelector('[data-nav-backdrop]');this.opener=this.querySelector('[data-menu-open]');this.querySelector('[data-menu-open]')?.addEventListener('click',()=>this.openMenu());this.querySelector('[data-menu-close]')?.addEventListener('click',()=>this.closeMenu());this.backdrop?.addEventListener('click',()=>this.closeMenu());document.addEventListener('keydown',(event)=>{if(event.key==='Escape')this.closeMenu();});} openMenu(){this.drawer?.classList.add('is-open');this.drawer?.setAttribute('aria-hidden','false');this.backdrop?.classList.add('is-open');document.body.style.overflow='hidden';window.setTimeout(()=>this.querySelector('[data-menu-close]')?.focus(),100);} closeMenu(){if(!this.drawer?.classList.contains('is-open'))return;this.drawer.classList.remove('is-open');this.drawer.setAttribute('aria-hidden','true');this.backdrop?.classList.remove('is-open');document.body.style.overflow='';this.opener?.focus();} } if(!customElements.get('moru-header-v2'))customElements.define('moru-header-v2',MoruHeaderV2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moru-header"] && !Shopify.designMode) return;
  try {
    
  class MoruHeader extends HTMLElement {
    connectedCallback() {
      this.navDrawer = this.querySelector('[data-nav-drawer]');
      this.backdrop = this.querySelector('[data-nav-backdrop]');

      this.querySelector('[data-menu-open]')?.addEventListener('click', () => this.openMenu());
      this.querySelector('[data-menu-close]')?.addEventListener('click', () => this.closeMenu());
      this.backdrop?.addEventListener('click', () => this.closeMenu());

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        this.closeMenu();
      });
    }

    openMenu() {
      this.navDrawer?.classList.add('is-open');
      this.navDrawer?.setAttribute('aria-hidden', 'false');
      this.backdrop?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    closeMenu() {
      this.navDrawer?.classList.remove('is-open');
      this.navDrawer?.setAttribute('aria-hidden', 'true');
      this.backdrop?.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  if (!customElements.get('moru-header')) {
    customElements.define('moru-header', MoruHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moru-hero"] && !Shopify.designMode) return;
  try {
    
  class MoruHeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.moru-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.moru-hero__dot'));
      this.current = 0;
      this.timer = null;
      this.interval = parseInt(this.dataset.interval, 10) || 6000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.slides.length < 2) return;
      this.dots.forEach((dot) => dot.addEventListener('click', () => { this.goTo(parseInt(dot.dataset.dotIndex, 10)); this.restart(); }));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.touchStartX = 0;
      this.addEventListener('touchstart', (e) => { this.touchStartX = e.changedTouches[0].screenX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        const delta = e.changedTouches[0].screenX - this.touchStartX;
        if (Math.abs(delta) > 45) { this.goTo(this.current + (delta < 0 ? 1 : -1)); this.restart(); }
      }, { passive: true });
      this.start();
    }
    disconnectedCallback() { this.stop(); }
    goTo(index) {
      const total = this.slides.length;
      const next = (index + total) % total;
      if (next === this.current) return;
      this.slides[this.current].classList.remove('is-active');
      this.dots[this.current].classList.remove('is-active');
      this.current = next;
      this.slides[this.current].classList.add('is-active');
      this.dots[this.current].classList.add('is-active');
    }
    start() { if (this.reducedMotion) return; this.stop(); this.timer = setInterval(() => this.goTo(this.current + 1), this.interval); }
    stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    restart() { this.stop(); this.start(); }
  }
  if (!customElements.get('moru-hero-slideshow')) customElements.define('moru-hero-slideshow', MoruHeroSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moru-main-cart"]) return;
  try {
    
  class MoruCart {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      root.addEventListener('click', (event) => {
        const minus = event.target.closest('[data-cart-minus]');
        const plus = event.target.closest('[data-cart-plus]');
        const remove = event.target.closest('[data-cart-remove]');
        const coupon = event.target.closest('[data-coupon-apply]');
        const memberCoupon = event.target.closest('[data-member-coupon-apply]');
        const couponClear = event.target.closest('[data-coupon-clear]');
        const upsell = event.target.closest('[data-upsell-add]');
        if (minus || plus) {
          const item = (minus || plus).closest('[data-line]');
          const input = item.querySelector('[data-cart-qty]');
          const next = Math.max(0, (parseInt(input.value, 10) || 0) + (plus ? 1 : -1));
          this.change(item.dataset.line, next);
        } else if (remove) {
          event.preventDefault();
          const item = remove.closest('[data-line]');
          this.change(item.dataset.line, 0);
        } else if (memberCoupon) {
          // JSが生きていれば入力欄に流し込んで通常の適用フローへ
          // (成功・不成立のメッセージが出る)。死んでいれば href の /discount へ
          const input = this.root.querySelector('[data-coupon-input]');
          if (input) {
            event.preventDefault();
            input.value = memberCoupon.dataset.code || '';
            this.applyCoupon();
          }
        } else if (coupon) this.applyCoupon();
        else if (couponClear) this.clearCoupons();
        else if (upsell) this.addUpsell(upsell);
      });
      root.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        if (!event.target.closest('[data-coupon-input]')) return;
        event.preventDefault();
        this.applyCoupon();
      });
      root.addEventListener('change', (event) => {
        const input = event.target.closest('[data-cart-qty]');
        if (!input) return;
        const item = input.closest('[data-line]');
        this.change(item.dataset.line, Math.max(0, parseInt(input.value, 10) || 0));
      });
    }
    get root_url() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
    async change(line, quantity) { await this.post('cart/change.js', { line:Number(line), quantity:quantity }); }
    async addUpsell(button) { button.disabled = true; await this.post('cart/add.js', { items:[{ id:Number(button.dataset.variantId), quantity:1 }] }); }
    async post(path, body) {
      try {
        const response = await fetch(this.root_url + path, { method:'POST', headers:{ 'Content-Type':'application/json' }, body:JSON.stringify(body) });
        if (!response.ok) throw new Error('cart request failed');
        await this.refresh();
      } catch (error) { window.location.reload(); }
    }
    async refresh() {
      const response = await fetch(window.location.pathname + '?section_id=' + this.sectionId);
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const next = parsed.querySelector('[data-cart-section]');
      if (!next) { window.location.reload(); return; }
      this.root.innerHTML = next.innerHTML;
      // セクションを丸ごと入れ替えるので直前のメッセージは消える。出し直す。
      if (this.pendingStatus) { this.showStatus(this.pendingStatus.message, this.pendingStatus.tone); this.pendingStatus = null; }
      document.dispatchEvent(new CustomEvent('moru:cart:updated'));
    }
    // 文言は locales が正。このブロックでは Liquid が展開されないので、
    // セクションが書き出した JSON を読む。コード名の差し込みは %code%。
    get strings() {
      const tag = this.root.querySelector('[data-coupon-strings]');
      if (!tag) return {};
      try { return JSON.parse(tag.textContent); } catch (error) { return {}; }
    }
    showStatus(message, tone) {
      const el = this.root.querySelector('[data-coupon-status]');
      if (!el) return;
      el.textContent = message; el.dataset.tone = tone || 'info'; el.hidden = false;
    }
    queueStatus(message, tone) { this.pendingStatus = { message:message, tone:tone }; }
    async fetchCart() {
      const response = await fetch(this.root_url + 'cart.js', { headers:{ Accept:'application/json' } });
      if (!response.ok) throw new Error('cart fetch failed');
      return response.json();
    }
    // `discount` は「いま効かせたいコードの全部」を渡す仕様。空文字で全解除(自動割引は無関係)。
    async setDiscount(value) {
      const response = await fetch(this.root_url + 'cart/update.js', { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({ discount:value }) });
      if (!response.ok) throw new Error('discount update failed');
      return response.json();
    }
    codeDiscountsOf(cart) {
      return ((cart && cart.cart_level_discount_applications) || []).filter((app) => app && app.type === 'discount_code');
    }
    async applyCoupon() {
      const input = this.root.querySelector('[data-coupon-input]');
      const button = this.root.querySelector('[data-coupon-apply]');
      const code = input ? input.value.trim() : '';
      if (!code) { this.showStatus(this.strings.empty, 'error'); if (input) input.focus(); return; }
      if (button) button.disabled = true;
      this.showStatus(this.strings.working, 'info');
      try {
        const before = await this.fetchCart();
        const beforeCodes = this.codeDiscountsOf(before).length;
        const after = await this.setDiscount(code);
        // 効いたかはカートが実際に変わったかで見る。併用できない自動割引のほうが
        // 得な場合 Shopify はコードを採用せず、割引額が動かない。
        const applied = this.codeDiscountsOf(after).length > beforeCodes ||
          Number(after.total_discount || 0) > Number(before.total_discount || 0);
        if (applied) {
          if (input) input.value = '';
          this.queueStatus(this.strings.success.replace('%code%', code), 'success');
        } else {
          // 「コードが誤り」と「他の割引のほうが得」が混ざる。Shopify 側に
          // 区別する手段が無いので、どちらか一方に決めつけない言い方にしてある。
          this.queueStatus(this.strings.notApplied, 'info');
        }
        await this.refresh();
      } catch (error) { this.showStatus(this.strings.error, 'error'); }
      finally { if (button) button.disabled = false; }
    }
    async clearCoupons() {
      try {
        await this.setDiscount('');
        this.queueStatus(this.strings.removed, 'info');
        await this.refresh();
      } catch (error) { this.showStatus(this.strings.error, 'error'); }
    }
  }
  document.querySelectorAll('[data-cart-section]').forEach((root) => { if (root.dataset.moruInit === 'true') return; root.dataset.moruInit = 'true'; new MoruCart(root); });
  document.addEventListener('change', async (event) => {
    const checkbox = event.target.closest('[data-cart-attribute]');
    if (!checkbox) return;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const attributes = {};
    attributes[checkbox.dataset.cartAttribute] = checkbox.checked ? 'true' : '';
    await fetch(root + 'cart/update.js', { method:'POST', headers:{ 'Content-Type':'application/json' }, body:JSON.stringify({ attributes:attributes }) });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moru-main-product"]) return;
  try {
    
  (function () {
    // PC: 後続セクション(数量割引/特徴/販促/詳細/スタイリング)を左カラム(__below)へ移す。
    // グリッドの右セルが2行ぶんに伸びるので、CSS sticky が商品名からページ下部まで効く。
    var below = document.querySelector('[data-moru-below]');
    if (!below) return;
    var mq = window.matchMedia('(min-width: 990px)');
    var roots = ['.moru-quantity-offers', '.moru-features', '.moru-details', '.moru-styling'];
    var moved = [];
    function collect() {
      var sections = [];
      roots.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          var section = el.closest('.shopify-section');
          if (section && sections.indexOf(section) === -1) sections.push(section);
        });
      });
      return sections;
    }
    function apply() {
      if (mq.matches) {
        if (moved.length) return;
        collect().forEach(function (section) {
          moved.push({ el: section, parent: section.parentNode, next: section.nextSibling });
          below.appendChild(section);
        });
      } else {
        while (moved.length) {
          var m = moved.pop();
          m.parent.insertBefore(m.el, m.next);
        }
      }
    }
    apply();
    mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
  })();

  (function () {
    var buyNow = document.querySelector('[data-moru-buy-now]');
    if (!buyNow) return;
    // チェックアウトから「戻る」で復帰すると bfcache が disabled のまま復元するため、
    // 表示のたびに必ず押せる状態に戻す
    window.addEventListener('pageshow', function () { buyNow.disabled = false; });
    buyNow.addEventListener('click', function () {
      var form = buyNow.closest('form');
      if (!form) return;
      buyNow.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          buyNow.disabled = false;
          window.alert(buyNow.dataset.error);
        });
    });
  })();

  (function () {
    var copyButton = document.querySelector('[data-product-coupon-copy]');
    if (!copyButton) return;
    var toast = document.querySelector('[data-product-coupon-toast]');
    var toastTimer = null;
    var showToast = function () {
      if (!toast) return;
      toast.hidden = false;
      window.requestAnimationFrame(function () { toast.classList.add('is-visible'); });
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () {
        toast.classList.remove('is-visible');
        window.setTimeout(function () { toast.hidden = true; }, 220);
      }, 2500);
    };
    copyButton.addEventListener('click', function () {
      var code = document.querySelector('[data-product-coupon-code]').textContent.trim();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showToast);
      } else {
        var textarea = document.createElement('textarea');
        textarea.value = code;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        showToast();
      }
    });
  })();

  /**
   * Stock label = real inventory minus what THIS shopper already holds in
   * their own cart. Shopify's cart is per browser session, so two people
   * looking at the same page each see their own number and the inventory
   * itself never moves. Backend stock only changes when an order is placed.
   */
  function moruParseJson(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return {};
    }
  }

  function renderStock(stockEl, variantId, available) {
    const mode = stockEl.dataset.mode;
    const inventory = moruParseJson(stockEl.dataset.inventory);
    const inCart = moruParseJson(stockEl.dataset.inCart);
    const threshold = parseInt(stockEl.dataset.threshold, 10) || 0;
    const label = stockEl.dataset.label || '';

    const stock = inventory[variantId];
    let remaining = typeof stock === 'number' ? stock - (inCart[variantId] || 0) : undefined;
    if (typeof remaining === 'number' && remaining < 0) remaining = 0;

    const remainingText =
      typeof remaining === 'number' && remaining > 0
        ? (stockEl.dataset.remaining || '').replace('__COUNT__', remaining)
        : '';

    const held = inCart[variantId] || 0;

    if (!available && held === 0) {
      stockEl.textContent = stockEl.dataset.soldOut || '';
    } else if (mode === 'hidden') {
      stockEl.textContent = '';
    } else if (remaining === 0 && held > 0) {
      // Not sold out — this shopper simply holds every remaining unit.
      stockEl.textContent = stockEl.dataset.allInCart || '';
    } else if (remaining === 0) {
      stockEl.textContent = stockEl.dataset.soldOut || '';
    } else if (mode === 'always') {
      stockEl.textContent = (label + ' ' + remainingText).trim();
    } else if (typeof remaining === 'number' && remaining > 0 && remaining <= threshold) {
      stockEl.textContent = (label + ' ' + remainingText).trim();
    } else {
      stockEl.textContent = '';
    }
  }

  // Re-read the cart after any add / quantity change and repaint the label.
  async function moruRefreshStockFromCart() {
    const stockEls = document.querySelectorAll('[data-moru-stock]');
    if (stockEls.length === 0) return;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    let cart;
    try {
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      cart = await response.json();
    } catch (error) {
      return;
    }

    const counts = {};
    (cart.items || []).forEach((item) => {
      counts[item.variant_id] = (counts[item.variant_id] || 0) + item.quantity;
    });

    stockEls.forEach((stockEl) => {
      stockEl.dataset.inCart = JSON.stringify(counts);
      const form = stockEl.closest('.moru-product__info') || document;
      const idInput = form.querySelector('[data-moru-variant-id]');
      const variantId = idInput ? Number(idInput.value) : NaN;
      if (!variantId) return;
      const inventory = moruParseJson(stockEl.dataset.inventory);
      renderStock(stockEl, variantId, (inventory[variantId] || 0) > 0);
    });
  }

  document.addEventListener('moru:cart:updated', moruRefreshStockFromCart);

  class MoruProductGallery extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.moru-product__slide'));
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      this.dialog = this.querySelector('[data-gallery-dialog]');
      this.dialogMedia = this.querySelector('[data-gallery-dialog-media]');
      this.index = 0;

      this.thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => this.select(i));
      });

      const prev = this.querySelector('[data-gallery-prev]');
      const next = this.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', () => this.select(this.index - 1));
      if (next) next.addEventListener('click', () => this.select(this.index + 1));

      const zoom = this.querySelector('[data-gallery-zoom]');
      if (zoom && this.dialog) zoom.addEventListener('click', () => this.openZoom());

      const close = this.querySelector('[data-gallery-close]');
      if (close && this.dialog) close.addEventListener('click', () => this.dialog.close());
      if (this.dialog) {
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
      }
    }

    select(index) {
      if (!this.slides.length) return;
      const total = this.slides.length;
      this.index = (index + total) % total;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
      this.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === this.index));
    }

    selectByMediaId(mediaId) {
      const target = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (target > -1) this.select(target);
    }

    openZoom() {
      const active = this.slides[this.index];
      const media = active && active.querySelector('img, svg');
      if (!media) return;
      this.dialogMedia.innerHTML = '';
      const clone = media.cloneNode(true);
      clone.removeAttribute('sizes');
      clone.removeAttribute('loading');
      this.dialogMedia.appendChild(clone);
      this.dialog.showModal();
    }
  }

  class MoruQuantity extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-qty-input]');
      const minus = this.querySelector('[data-qty-minus]');
      const plus = this.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', () => this.step(-1));
      if (plus) plus.addEventListener('click', () => this.step(1));
    }

    step(delta) {
      const current = parseInt(this.input.value, 10) || 1;
      this.input.value = Math.max(1, current + delta);
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  class MoruVariantPicker extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('[data-variant-json]');
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.product = this.closest('[data-moru-product]');

      // セールの判定材料は Liquid が data 属性で渡してくる(正本は
      // shop metafield custom.moru_promotions_config)。
      this.saleRate = parseInt((this.product && this.product.dataset.moruSaleRate) || '0', 10) || 0;
      this.saleExcluded = new Set(
        (((this.product && this.product.dataset.moruSaleExcluded) || '')
          .split(',')
          .map((id) => id.trim())
          .filter(Boolean))
      );

      this.addEventListener('change', () => this.onChange());
    }

    get selectedValues() {
      return Array.from(this.querySelectorAll('input[type="radio"]:checked')).map((input) => input.value);
    }

    formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
      return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
    }

    onChange() {
      const values = this.selectedValues;
      const variant = this.variants.find((candidate) =>
        candidate.options.every((option, index) => option === values[index])
      );

      this.querySelectorAll('[data-moru-option-value]').forEach((el) => {
        const position = parseInt(el.dataset.moruOptionValue, 10);
        if (values[position - 1]) el.textContent = values[position - 1];
      });

      const idInput = this.product.querySelector('[data-moru-variant-id]');
      const priceEl = this.product.querySelector('[data-moru-price]');
      const compareEl = this.product.querySelector('[data-moru-compare]');
      const subtitleEl = this.product.querySelector('[data-moru-variant-subtitle]');
      const addButton = this.product.querySelector('[data-moru-add-button]');
      const addLabel = this.product.querySelector('[data-moru-add-label]');
      const stockEl = this.product.querySelector('[data-moru-stock]');
      const gallery = this.product.querySelector('moru-product-gallery');

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = addLabel.dataset.soldOut;
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (subtitleEl) subtitleEl.textContent = variant.title;

      // SUMMER SALE。Liquid 側と同じ計算(切り捨て)にそろえる。
      // ずれると初期表示と切り替え後で違う金額が出る。
      const onSale = this.saleRate > 0 && !this.saleExcluded.has(String(variant.id));
      const shownPrice = onSale
        ? Math.floor((variant.price * (100 - this.saleRate)) / 100)
        : variant.price;

      if (priceEl) {
        priceEl.textContent = this.formatMoney(shownPrice);
        priceEl.classList.toggle('moru-product__price--sale', onSale);
      }

      if (compareEl) {
        if (onSale) {
          // セール中は「定価に線」= その Variant の通常価格を出す
          compareEl.textContent = this.formatMoney(variant.price);
          compareEl.hidden = false;
        } else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = this.formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) {
        addLabel.textContent = variant.available ? addLabel.dataset.available : addLabel.dataset.soldOut;
      }

      if (stockEl) renderStock(stockEl, variant.id, variant.available);

      if (gallery && variant.featured_media) {
        gallery.selectByMediaId(variant.featured_media.id);
      }

      if (this.dataset.url) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
  }

  if (!customElements.get('moru-product-gallery')) {
    customElements.define('moru-product-gallery', MoruProductGallery);
  }
  if (!customElements.get('moru-quantity')) {
    customElements.define('moru-quantity', MoruQuantity);
  }
  if (!customElements.get('moru-variant-picker')) {
    customElements.define('moru-variant-picker', MoruVariantPicker);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-moru-wishlist]');
    if (!button) return;
    const pressed = button.getAttribute('aria-pressed') === 'true';
    button.setAttribute('aria-pressed', pressed ? 'false' : 'true');
    const label = button.querySelector('[data-moru-wishlist-label]');
    if (label) label.textContent = pressed ? label.dataset.add : label.dataset.added;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moru-page-content"] && !Shopify.designMode) return;
  try {
    
  class MoruPageToc extends HTMLElement {
    connectedCallback() {
      const nav = this.querySelector('[data-moru-toc]');
      const list = this.querySelector('[data-moru-toc-list]');
      const rte = this.querySelector('[data-moru-rte]');

      if (!nav || !list || !rte) return;

      const headings = rte.querySelectorAll('h2');
      if (headings.length < 2) return;

      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `moru-section-${index + 1}`;

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.appendChild(link);
        list.appendChild(item);
      });

      nav.hidden = false;
    }
  }

  if (!customElements.get('moru-page-toc')) {
    customElements.define('moru-page-toc', MoruPageToc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moru-product-bundle"] && !Shopify.designMode) return;
  try {
    
  class MoruBundleAdd extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-bundle-add]');
      if (!this.button) return;
      this.button.addEventListener('click', () => this.add());
    }

    async add() {
      let items;
      try {
        items = JSON.parse(this.button.dataset.items);
      } catch (error) {
        return;
      }

      this.button.disabled = true;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        });
        if (response.ok) {
          window.location.href = root + 'cart';
          return;
        }
      } catch (error) {
        // fall through to re-enable the button
      }

      this.button.disabled = false;
    }
  }

  if (!customElements.get('moru-bundle-add')) {
    customElements.define('moru-bundle-add', MoruBundleAdd);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moru-quantity-offers"] && !Shopify.designMode) return;
  try {
    
  class MoruQuantityOffers extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.product = document.querySelector('[data-moru-product]');
      if (!this.product) return;
      this.form = this.product.querySelector('.moru-product__form');
      this.quantityInput = this.product.querySelector('[data-qty-input]');
      this.variantInput = this.product.querySelector('[data-moru-variant-id]');
      this.addLabel = this.product.querySelector('[data-moru-add-label]');
      this.addButton = this.product.querySelector('[data-moru-add-button]');
      this.variants = this.parseVariants();
      this.twoDiscount = Number(this.dataset.twoDiscount) || 0;
      this.threeDiscount = Number(this.dataset.threeDiscount) || 0;
      this.currency = this.dataset.currency || 'JPY';
      this.selectedQuantity = 1;
      this.originalAddLabel = this.addLabel ? this.addLabel.textContent.trim() : 'カートに追加';
      this.mix = this.querySelector('[data-offer-mix]');
      this.singleMulti = this.querySelector('[data-offer-single-multi]');
      this.slotsContainer = this.querySelector('[data-offer-slots]');
      this.slotTemplate = this.querySelector('[data-offer-slot-template]');
      this.status = this.querySelector('[data-offer-status]');
      this.hasVariantMix = Boolean(this.slotTemplate && this.slotsContainer);

      const quantityRow = this.product.querySelector('.moru-product__qty-row');
      if (quantityRow && quantityRow.parentNode && this.parentNode !== quantityRow.parentNode) quantityRow.parentNode.insertBefore(this, quantityRow);
      this.product.classList.add('moru-has-quantity-offers');

      this.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-quantity-choice]');
        if (choice) {
          const requested = Number(choice.dataset.quantityChoice) || 1;
          this.setQuantity(requested >= 3 ? 3 : requested, true);
          return;
        }
        if (event.target.closest('[data-offer-add-one]')) {
          this.setQuantity(Math.max(3, this.selectedQuantity + 1), false);
          return;
        }
        if (event.target.closest('[data-offer-remove-one]') && this.selectedQuantity > 3) {
          this.setQuantity(this.selectedQuantity - 1, false);
        }
      });

      document.addEventListener('change', (event) => {
        const select = event.target.closest('[data-offer-variant-select]');
        if (select && this.contains(select)) {
          select.dataset.touched = 'true';
          this.updateSlotPrice(select);
          this.refreshPrices();
          return;
        }
        if (!event.target.closest('moru-variant-picker')) return;
        requestAnimationFrame(() => {
          this.syncFirstSlotToMainVariant();
          this.refreshPrices();
        });
      });

      if (this.form) this.form.addEventListener('submit', (event) => this.onSubmit(event), true);
      this.setQuantity(1, true);
    }

    parseVariants() {
      const node = this.querySelector('[data-offer-variants]');
      if (!node) return [];
      try { return JSON.parse(node.textContent); } catch (error) { return []; }
    }

    availableVariants() { return this.variants.filter((variant) => variant.available); }

    selectedVariant() {
      const id = Number(this.variantInput && this.variantInput.value);
      return this.variants.find((variant) => Number(variant.id) === id) || this.availableVariants()[0] || this.variants[0];
    }

    discountFor(quantity) { return quantity >= 3 ? this.threeDiscount : quantity === 2 ? this.twoDiscount : 0; }

    formatMoney(cents) {
      try { return new Intl.NumberFormat('ja-JP', { style:'currency', currency:this.currency, maximumFractionDigits:0 }).format(cents / 100); }
      catch (error) { return '¥' + Math.round(cents / 100).toLocaleString('ja-JP'); }
    }

    setQuantity(quantity, resetToTier) {
      this.selectedQuantity = Math.max(1, Number(quantity) || 1);
      if (resetToTier && this.selectedQuantity >= 3) this.selectedQuantity = 3;

      if (this.hasVariantMix) {
        if (this.selectedQuantity > 1) this.ensureSlots(this.selectedQuantity);
        else this.ensureSlots(0);
        if (this.mix) this.mix.hidden = this.selectedQuantity <= 1;
        if (this.quantityInput) this.quantityInput.value = 1;
      } else {
        if (this.singleMulti) this.singleMulti.hidden = this.selectedQuantity <= 1;
        if (this.quantityInput) this.quantityInput.value = this.selectedQuantity;
      }

      this.querySelectorAll('[data-quantity-choice]').forEach((choice) => {
        const tier = Number(choice.dataset.quantityChoice);
        const selected = tier === 3 ? this.selectedQuantity >= 3 : tier === this.selectedQuantity;
        choice.classList.toggle('is-selected', selected);
        choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      this.querySelectorAll('[data-offer-three-actions]').forEach((actions) => { actions.hidden = this.selectedQuantity < 3; });
      this.querySelectorAll('[data-offer-active-count]').forEach((node) => { node.textContent = this.selectedQuantity + '点'; });
      this.querySelectorAll('[data-offer-remove-one]').forEach((button) => { button.disabled = this.selectedQuantity <= 3; });
      this.querySelectorAll('[data-offer-fixed-count]').forEach((node) => { node.hidden = this.selectedQuantity >= 3; node.textContent = this.selectedQuantity + '点'; });

      if (this.addLabel) this.addLabel.textContent = this.selectedQuantity > 1 ? `選んだ${this.selectedQuantity}点をカートに追加` : this.originalAddLabel;
      if (this.status) this.status.textContent = '';
      this.refreshPrices();
    }

    ensureSlots(count) {
      if (!this.hasVariantMix) return;
      while (this.slotsContainer.children.length > count) this.slotsContainer.lastElementChild.remove();
      while (this.slotsContainer.children.length < count) {
        const index = this.slotsContainer.children.length;
        const fragment = this.slotTemplate.content.cloneNode(true);
        const slot = fragment.querySelector('[data-offer-slot]');
        const number = slot.querySelector('[data-offer-slot-number]');
        const select = slot.querySelector('[data-offer-variant-select]');
        number.textContent = `${index + 1}点目`;
        select.setAttribute('aria-label', `${index + 1}点目の種類・カラー`);
        this.prefillSelect(select, index);
        this.slotsContainer.appendChild(fragment);
        this.updateSlotPrice(this.slotsContainer.lastElementChild.querySelector('[data-offer-variant-select]'));
      }
    }

    prefillSelect(select, index) {
      const available = this.availableVariants();
      if (!available.length) return;
      const current = this.selectedVariant() || available[0];
      const currentIndex = Math.max(0, available.findIndex((variant) => Number(variant.id) === Number(current.id)));
      const candidate = index === 0 ? current : (available[(currentIndex + index) % available.length] || current);
      select.value = String(candidate.id);
    }

    slotSelects() { return this.hasVariantMix ? Array.from(this.slotsContainer.querySelectorAll('[data-offer-variant-select]')) : []; }

    syncFirstSlotToMainVariant() {
      const first = this.slotSelects()[0];
      const current = this.selectedVariant();
      if (!first || !current) return;
      first.value = String(current.id);
      this.updateSlotPrice(first);
    }

    updateSlotPrice(select) {
      if (!select) return;
      const option = select.options[select.selectedIndex];
      const price = Number(option && option.dataset.price) || 0;
      const priceEl = select.closest('[data-offer-slot]')?.querySelector('[data-offer-slot-price]');
      if (priceEl) priceEl.textContent = this.formatMoney(price);
    }

    selectedItems(quantity = this.selectedQuantity) {
      const current = this.selectedVariant();
      if (!current) return [];
      if (!this.hasVariantMix || quantity <= 1) return Array.from({ length: quantity }, () => current);
      return this.slotSelects().slice(0, quantity).map((select) => {
        const id = Number(select.value);
        return this.variants.find((variant) => Number(variant.id) === id);
      }).filter(Boolean);
    }

    totalsFor(quantity, useSelection) {
      const current = this.selectedVariant();
      let items = [];
      if (useSelection && quantity > 1) items = this.selectedItems(quantity);
      else if (current) items = Array.from({ length: quantity }, () => current);
      const original = items.reduce((sum, variant) => sum + (Number(variant.price) || 0), 0);
      const discount = this.discountFor(quantity);
      const saving = Math.round(original * discount / 100);
      return { original, saving, final: original - saving };
    }

    refreshPrices() {
      const one = this.totalsFor(1, false);
      const two = this.totalsFor(2, this.selectedQuantity === 2);
      const threeQuantity = this.selectedQuantity >= 3 ? this.selectedQuantity : 3;
      const three = this.totalsFor(threeQuantity, this.selectedQuantity >= 3);

      const oneFinal = this.querySelector('[data-offer-final-total="1"]');
      if (oneFinal) oneFinal.textContent = this.formatMoney(one.final);
      this.setTierPrice(2, two);
      this.setTierPrice(3, three);
      const countLabel = this.querySelector('[data-offer-three-count]');
      if (countLabel) countLabel.textContent = `${threeQuantity}点合計`;

      if (this.selectedQuantity > 1 && this.hasVariantMix) {
        const totals = this.totalsFor(this.selectedQuantity, true);
        const label = this.querySelector('[data-mix-label]');
        const original = this.querySelector('[data-mix-original]');
        const final = this.querySelector('[data-mix-final]');
        const saving = this.querySelector('[data-mix-saving]');
        if (label) label.textContent = `選択中：${this.selectedQuantity}点`;
        if (original) original.textContent = this.formatMoney(totals.original);
        if (final) final.textContent = this.formatMoney(totals.final);
        if (saving) saving.textContent = this.formatMoney(totals.saving) + ' お得';
      }
    }

    setTierPrice(tier, totals) {
      const original = this.querySelector(`[data-offer-original-total="${tier}"]`);
      const final = this.querySelector(`[data-offer-final-total="${tier}"]`);
      const saving = this.querySelector(`[data-offer-savings="${tier}"]`);
      if (original) original.textContent = this.formatMoney(totals.original);
      if (final) final.textContent = this.formatMoney(totals.final);
      if (saving) saving.textContent = this.formatMoney(totals.saving) + ' お得';
    }

    async onSubmit(event) {
      if (this.selectedQuantity <= 1) {
        if (this.quantityInput) this.quantityInput.value = 1;
        return;
      }

      if (!this.hasVariantMix) {
        if (this.quantityInput) this.quantityInput.value = this.selectedQuantity;
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      const items = this.selectedItems();
      if (items.length !== this.selectedQuantity) {
        if (this.status) this.status.textContent = '種類・カラーを選択してください。';
        return;
      }

      const grouped = new Map();
      items.forEach((variant) => {
        const id = Number(variant.id);
        grouped.set(id, (grouped.get(id) || 0) + 1);
      });
      const payload = { items: Array.from(grouped, ([id, quantity]) => ({ id, quantity })) };
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (this.addButton) this.addButton.disabled = true;
      if (this.status) this.status.textContent = '';

      try {
        const response = await fetch(root + 'cart/add.js', {
          method:'POST',
          headers:{ 'Content-Type':'application/json', Accept:'application/json' },
          body:JSON.stringify(payload)
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || '追加できませんでした');
        }
        const drawer = document.querySelector('[data-cart-drawer]');
        if (drawer && typeof drawer.refresh === 'function') {
          await drawer.refresh();
          if (typeof drawer.open === 'function') drawer.open();
        } else {
          document.dispatchEvent(new CustomEvent('moru:cart:updated'));
        }
      } catch (error) {
        if (this.status) this.status.textContent = error.message || 'カートへの追加に失敗しました。';
      } finally {
        if (this.addButton) this.addButton.disabled = false;
      }
    }
  }

  if (!customElements.get('moru-quantity-offers')) customElements.define('moru-quantity-offers', MoruQuantityOffers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moru-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  class MoruRecentlyViewed extends HTMLElement {
    static STORAGE_KEY = 'moru:recently-viewed';
    static MAX_AGE = 1000 * 60 * 60 * 24 * 30;

    connectedCallback() {
      this.list = this.querySelector('[data-recent-items]');
      this.max = parseInt(this.dataset.max, 10) || 4;
      this.currentHandle = this.dataset.currentHandle || '';

      const clearButton = this.querySelector('[data-recent-clear]');
      if (clearButton) {
        clearButton.addEventListener('click', () => {
          this.write([]);
          this.render();
        });
      }

      this.remember();
      this.render();
    }

    read() {
      try {
        const raw = window.localStorage.getItem(MoruRecentlyViewed.STORAGE_KEY);
        if (!raw) return [];
        const now = Date.now();
        return JSON.parse(raw).filter(
          (entry) => entry && entry.handle && entry.html && now - entry.at < MoruRecentlyViewed.MAX_AGE
        );
      } catch (error) {
        return [];
      }
    }

    write(entries) {
      try {
        window.localStorage.setItem(MoruRecentlyViewed.STORAGE_KEY, JSON.stringify(entries));
      } catch (error) {
        /* storage unavailable — recently viewed simply does not persist */
      }
    }

    remember() {
      const self = document.querySelector('[data-recent-self]');
      if (!self || !self.dataset.handle) return;

      const entries = this.read().filter((entry) => entry.handle !== self.dataset.handle);
      entries.unshift({
        handle: self.dataset.handle,
        html: self.innerHTML.trim(),
        at: Date.now(),
      });
      this.write(entries.slice(0, 12));
    }

    render() {
      const entries = this.read().filter((entry) => entry.handle !== this.currentHandle);
      const designMode = window.Shopify && window.Shopify.designMode;

      this.list.innerHTML = '';

      if (entries.length === 0) {
        if (!designMode) {
          this.hidden = true;
          return;
        }
        const placeholder = document.querySelector('[data-recent-placeholder]');
        if (placeholder) this.list.appendChild(placeholder.content.cloneNode(true));
        this.hidden = false;
        return;
      }

      entries.slice(0, this.max).forEach((entry) => {
        const item = document.createElement('li');
        item.innerHTML = entry.html;
        this.list.appendChild(item);
      });

      this.hidden = false;
    }
  }

  if (!customElements.get('moru-recently-viewed')) {
    customElements.define('moru-recently-viewed', MoruRecentlyViewed);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moru-search-modal"] && !Shopify.designMode) return;
  try {
    
  const MORU_RECENT_SEARCH_KEY = 'moru:recent-searches';

  class MoruSearchModal extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-modal-input]');
      this.results = this.querySelector('[data-modal-results]');
      this.hints = this.querySelector('[data-modal-hints]');
      this.recentGroup = this.querySelector('[data-modal-recent]');
      this.recentList = this.querySelector('[data-modal-recent-list]');
      this.form = this.querySelector('form');
      this.controller = null;
      this.timer = null;
      this.opener = null;

      this.querySelector('[data-modal-close]')?.addEventListener('click', () => this.close());
      this.querySelector('[data-modal-backdrop]')?.addEventListener('click', () => this.close());
      this.querySelector('[data-modal-recent-clear]')?.addEventListener('click', () => this.clearRecent());

      this.input?.addEventListener('input', () => this.onInput());
      this.input?.addEventListener('keydown', (event) => this.onKeydown(event));
      this.form?.addEventListener('submit', () => this.remember(this.input.value));

      document.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-search-toggle]');
        if (!toggle) return;
        event.preventDefault();
        this.open(toggle);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
      });

      this.renderRecent();
    }

    get rootUrl() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    // The Predictive Search API only answers for a fixed set of buyer locales,
    // and Japanese is not one of them (/search/suggest returns 417). Shopify
    // reports the capability in #shopify-features, so read it rather than
    // firing a request per keystroke that can never succeed.
    get predictiveSupported() {
      if (this._predictive === undefined) {
        try {
          const node = document.getElementById('shopify-features');
          this._predictive = !!(node && JSON.parse(node.textContent).predictiveSearch);
        } catch (error) {
          this._predictive = false;
        }
      }
      return this._predictive;
    }

    suggestUrl(query) {
      if (this.predictiveSupported) {
        return (
          this.rootUrl +
          'search/suggest?' +
          new URLSearchParams({
            q: query,
            'resources[type]': 'product,article,page',
            'resources[limit]': '6',
            'resources[options][unavailable_products]': 'last',
            section_id: 'moru-predictive-search',
          }).toString()
        );
      }

      // Fallback: the ordinary search index, rendered through the same section.
      return (
        this.rootUrl +
        'search?' +
        new URLSearchParams({
          q: query,
          'options[prefix]': 'last',
          section_id: 'moru-predictive-search',
        }).toString()
      );
    }

    open(opener) {
      this.opener = opener || null;
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      this.renderRecent();
      window.setTimeout(() => this.input?.focus(), 120);
    }

    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      this.input?.setAttribute('aria-expanded', 'false');
      if (this.opener && typeof this.opener.focus === 'function') this.opener.focus();
    }

    get options() {
      return Array.from(this.results.querySelectorAll('.moru-predictive__item'));
    }

    onKeydown(event) {
      const options = this.options;
      if (options.length === 0) return;

      const current = options.findIndex((option) => option.classList.contains('is-highlighted'));

      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const step = event.key === 'ArrowDown' ? 1 : -1;
        const next = (current + step + options.length + 1) % (options.length + 1);
        options.forEach((option) => option.classList.remove('is-highlighted'));
        if (next < options.length) {
          options[next].classList.add('is-highlighted');
          options[next].scrollIntoView({ block: 'nearest' });
        }
      } else if (event.key === 'Enter' && current > -1) {
        event.preventDefault();
        this.remember(this.input.value);
        window.location.href = options[current].getAttribute('href');
      }
    }

    onInput() {
      window.clearTimeout(this.timer);
      const query = this.input.value.trim();

      if (query.length < 2) {
        this.results.innerHTML = '';
        this.input.setAttribute('aria-expanded', 'false');
        if (this.hints) this.hints.hidden = false;
        return;
      }

      this.timer = window.setTimeout(() => this.suggest(query), 250);
    }

    async suggest(query) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      try {
        const response = await fetch(this.suggestUrl(query), {
          signal: this.controller.signal,
        });
        if (!response.ok) throw new Error(String(response.status));

        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const markup = parsed.querySelector('[data-predictive-root]');
        if (!markup) return;

        this.results.innerHTML = markup.innerHTML;
        this.input.setAttribute('aria-expanded', 'true');
        if (this.hints) this.hints.hidden = true;
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.results.innerHTML = '';
        this.input.setAttribute('aria-expanded', 'false');
        if (this.hints) this.hints.hidden = false;
      }
    }

    readRecent() {
      if (this.dataset.recent !== 'true') return [];
      try {
        const raw = window.localStorage.getItem(MORU_RECENT_SEARCH_KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }

    remember(value) {
      if (this.dataset.recent !== 'true') return;
      const term = (value || '').trim();
      if (!term) return;
      try {
        const next = [term].concat(this.readRecent().filter((item) => item !== term)).slice(0, 6);
        window.localStorage.setItem(MORU_RECENT_SEARCH_KEY, JSON.stringify(next));
      } catch (error) {
        /* storage unavailable — recent searches are a convenience only */
      }
    }

    clearRecent() {
      try {
        window.localStorage.removeItem(MORU_RECENT_SEARCH_KEY);
      } catch (error) {
        /* nothing to clear */
      }
      this.renderRecent();
    }

    renderRecent() {
      if (!this.recentGroup || !this.recentList) return;
      const terms = this.readRecent();

      if (terms.length === 0) {
        this.recentGroup.hidden = true;
        this.recentList.textContent = '';
        return;
      }

      this.recentList.textContent = '';
      terms.forEach((term) => {
        const link = document.createElement('a');
        link.className = 'moru-pill';
        link.href = this.rootUrl + 'search?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
        link.textContent = term;
        this.recentList.appendChild(link);
      });
      this.recentGroup.hidden = false;
    }
  }

  if (!customElements.get('moru-search-modal')) {
    customElements.define('moru-search-modal', MoruSearchModal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moru-search"] && !Shopify.designMode) return;
  try {
    
  class MoruSearchResults {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.items = root.querySelector('[data-search-items]');
      this.button = root.querySelector('[data-search-more]');
      this.shownText = root.querySelector('[data-search-shown]');

      const sortSelect = root.querySelector('[data-search-sort]');
      if (sortSelect) {
        sortSelect.addEventListener('change', () => {
          const form = sortSelect.closest('form');
          if (form) form.submit();
        });
      }

      if (this.button) {
        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          this.loadMore();
        });
      }
    }

    async loadMore() {
      const url = this.button.getAttribute('href');
      if (!url) return;

      const original = this.button.textContent;
      this.button.setAttribute('aria-disabled', 'true');

      try {
        const separator = url.indexOf('?') > -1 ? '&' : '?';
        const response = await fetch(url + separator + 'sections=' + this.sectionId);
        const data = await response.json();
        const parsed = new DOMParser().parseFromString(data[this.sectionId], 'text/html');

        const newItems = parsed.querySelector('[data-search-items]');
        if (newItems) {
          Array.from(newItems.children).forEach((child) => this.items.appendChild(child));
        }

        const newShown = parsed.querySelector('[data-search-shown]');
        if (newShown && this.shownText) this.shownText.textContent = newShown.textContent;

        const newButton = parsed.querySelector('[data-search-more]');
        if (newButton) {
          this.button.setAttribute('href', newButton.getAttribute('href'));
          this.button.removeAttribute('aria-disabled');
        } else {
          this.button.remove();
        }
      } catch (error) {
        this.button.textContent = original;
        this.button.removeAttribute('aria-disabled');
      }
    }
  }

  document.querySelectorAll('[data-search-results]').forEach((root) => {
    if (root.dataset.moruInit === 'true') return;
    root.dataset.moruInit = 'true';
    new MoruSearchResults(root);
  });

  } catch(e) { console.error(e); }
})();
})();
